
import { Vue, Component, Prop } from 'vue-property-decorator';
import Model from './model';
import MenuComponents from '@/components/menu.vue';
import PageComponents from '@/components/page.vue';

// 必须使用@Component注解
@Component({
  components: {
    MenuComponents,
    PageComponents,
  },
})
export default class MypageVue extends Vue {
  private model = new Model();
  private pageBean = {
    page: 1,
    rows: 10,
    totalPages: 0, // 总页数
    totalNums: 0, // 总记录条数
  };

  private aaa: string = '';
  private curPicUrl: string = '';

  private useStatusCondition: any = null; // 使用状态

  private tableData: any = [];

  // 分页组件的值修改后，会调用该方法
  private async pageChange(data: any) {
    this.pageBean = data;
    this.findPageByWhere();
  }

  private async pp(str: any) {
    alert(222);
    // alert(str);
  }
  // 添加邀请码
  private async addTbInviteCode() {
    const flag = await Vue.prototype.$confirm('确定添加吗？');
    if (flag) {
      // 调用添加邀请码方法
      const result = await this.model.add({});
      if (result && result.success === true) {
        Vue.prototype.$message.success('添加成功');
        this.pageBean.page = 1;
        this.findPageByWhere();
      } else {
        Vue.prototype.$message.success('添加失败');
      }
    }
  }

  // 换页，num是当前最新要请求的页
  private async handleCurrentChange(num: number) {
    this.findPageByWhere();
  }

  // 跳转到编辑页面
  private async edit(id: string) {
    // this.$router.push({ path: '/pic?tbPicId='+id, params: {tbPicId:id} });
    // 下面参数可以用query，不能用params，因为官网说了，有path属性，params会被忽略
    this.$router.push({ path: '/pic', query: { tbPicId: id } });
  }

  // 删除上传记录
  private async deleteData(id: string) {
    const flag = await Vue.prototype.$confirm('确定删除吗？');
    if (flag) {
      const param = {
        equal: {
          id,
        },
      };
      const result = await this.model.delete(param);
      if (result) {
        Vue.prototype.$message.success('删除成功');
        // 重新计算当前页
        if (this.pageBean.page > 1) {
          const yushu = this.pageBean.totalNums % this.pageBean.rows;
          if (yushu === 1) {
            --this.pageBean.page;
          }
        }
        this.findPageByWhere();
      } else {
        Vue.prototype.$message.error('删除失败');
      }
    }
  }

  // 分页查找
  private async findPageByWhere() {
    // const param = {
    //   equal:{
    //     username: this.username,
    //     password: this.password
    //   }
    // };

    let param = null;

    // 不为空，需要根据状态查询
    if (this.useStatusCondition) {
      param = {
        page: this.pageBean.page,
        rows: this.pageBean.rows,
        equal: {
          useStatus: this.useStatusCondition,
        },
      };
    } else {
      param = {
        page: this.pageBean.page,
        rows: this.pageBean.rows,
      };
    }
    const result = await this.model.findPageByWhere(param);
    if (result) {
      if (result.success === true) {
        let tData: any = [];
        tData = result.data.data;
        for (const obj of tData) {
          if (obj.useStatus === 1) {
            obj.useStatus = '未使用';
          } else {
            obj.useStatus = '已使用';
          }
        }
        this.tableData = tData;
        this.pageBean.totalPages = result.data.totalPages;
        this.pageBean.totalNums = result.data.totalNums;
      } else {
        Vue.prototype.$message.info('数据为空');
      }
    }
  }
  private async mounted() {
    this.findPageByWhere();
  }
}
